
export default class PersonnelHiringHistory {
    userId: number;
    id: number;
    lmNo: number;
    tranDate: Date;
    tranType: string;
    hireByNo: number;
    hireBy: string;
    tranByNo: number;
    tranBy: string;
    timestamp: string;
    notes: string;
}


// WEBPACK FOOTER //
// ./src/models/personnel/PersonnelHiringHistory.ts